import React from "react";
import { Link } from "react-router-dom";
import useUserRole from "../../hooks/useUserRole";
import useRolePermissions from "../../hooks/useRolePermissions";
import "./AdminPortalHome.css";

export default function EmployeesHome() {
  const { role, loading: roleLoading } = useUserRole();
  const { can, loading: permsLoading } = useRolePermissions(role);

  if (roleLoading || permsLoading) {
    return <div className="adminWrap">Loading…</div>;
  }

  return (
    <div className="adminWrap">
      <div className="adminHeader">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <h1>Employees</h1>
            <div className="adminRole">
              Manage employees, applications, and onboarding
            </div>
          </div>

          <Link to="/admin" className="btn btn-secondary">
            Return to Admin Portal
          </Link>
        </div>
      </div>

      <div className="adminModuleGrid">
        {can("EmployeesRead") && (
          <Link to="/admin/employee-list" className="adminModuleCard">
            <div className="adminModuleTitle">Employee List</div>
            <div className="adminModuleHint">
              Staff profiles, roles, permissions, and status management
            </div>
          </Link>
        )}

        {can("ApplicationsRead") && (
          <Link to="/admin/applications" className="adminModuleCard">
            <div className="adminModuleTitle">Applications</div>
            <div className="adminModuleHint">
              Review, activate, and manage applicant submissions
            </div>
          </Link>
        )}

        {!can("EmployeesRead") && !can("ApplicationsRead") && (
          <p>You do not have access to employee or application tools.</p>
        )}
      </div>
    </div>
  );
}